// postSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Post } from "../../type/post.type";
import toast from "react-hot-toast";

type PostState = {
  posts: Post[];
};

const initialState: PostState = {
  posts: [],
};

const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {
    setPosts: (state, action: PayloadAction<Post[]>) => {
      state.posts = action.payload;
      console.log("all initial post-->", state.posts);
    },

    addPost: (state, action: PayloadAction<Post>) => {
      state.posts.push(action.payload);
    },

    updatePost: (
      state,
      action: PayloadAction<{ _id: string; updates: Partial<Post> }>
    ) => {
      const postIndex = state.posts.findIndex(
        (post) => post._id === action.payload._id
      );
      if (postIndex !== -1) {
        state.posts[postIndex] = {
          ...state.posts[postIndex],
          ...action.payload.updates,
        };
      }
      toast.success("New!!");
    },

    deletePost: (state, action: PayloadAction<string>) => {
      state.posts = state.posts.filter((post) => post._id !== action.payload);
    },

    handleLike: (
      state,
      action: PayloadAction<{ postId: string; userId: string }>
    ) => {
      const { userId, postId } = action.payload;
      const postIndex = state.posts.findIndex((post) => post._id === postId);

      if (postIndex !== -1) {
        const post = state.posts[postIndex];
        console.log("first", post);
        const alreadyLike = post.likes.includes(userId);

        if (alreadyLike) {
          state.posts[postIndex] = {
            ...post,
            likes: post.likes.filter((id) => id !== userId),
          };
        } else {
          state.posts[postIndex] = {
            ...post,
            likes: [...post.likes, userId],
          };
        }
      }
    },

    addComment: (state, action: PayloadAction<any>) => {
      const postIndex = state.posts.findIndex(
        (post) => post._id === action.payload.post
      );
      if (postIndex !== -1) {
        state.posts[postIndex].comment.push(action.payload);
      }
    },

    deleteComment: (
      state,
      action: PayloadAction<{ postId: string; commentId: string }>
    ) => {
      const postIndex = state.posts.findIndex(
        (post) => post._id === action.payload.postId
      );
      if (postIndex !== -1) {
        state.posts[postIndex].comment = state.posts[postIndex].comment.filter(
          (comment) => comment.id !== action.payload.commentId
        );
      }
    },
  },
});

export const {
  setPosts,
  addPost,
  updatePost,
  deletePost,
  handleLike,
  addComment,
  deleteComment,
} = postSlice.actions;
export default postSlice.reducer;
